import { FC } from "react";
import PoweredBy from "./PoweredBy";

const AppFooter: FC = () => (
  <footer className="formalys-app-footer">
    <span>© {new Date().getFullYear()} Formalys</span>
    <span aria-hidden="true">·</span>
    <PoweredBy />
  </footer>
);

export default AppFooter;
